export const nameRoleArr = [
	{
		name: "IDP Admin",
		role: "idp_admin",
	},
	{
		name: "Infrastructure Admin",
		role: "infrastructure_admin",
	},
	{
		name: "Cluster Owner",
		role: "cluster_owner",
	},
	{
		name: "Application Owner",
		role: "application_owner",
	},
	{
		name: "Developer",
		role: "developer",
	},
	{
		name: "Viewer",
		role: "viewer",
	},
];
export const nameRoleObj: any = {
	idp_admin: "IDP Admin",
	infrastructure_admin: "Infrastructure Admin",
	cluster_owner: "Cluster Owner",
	application_owner: "Application Owner",
	developer: "Developer",
	viewer: "Viewer",
};
